import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup,Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { UtilService } from '../services/util.service';
import { ApiService } from '../services/api.service';
import Swal from "sweetalert2";
import { Country, State } from 'src/app/services/locationModal';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { GigsumoService } from '../services/gigsumoService';
import { AppSettings } from '../services/AppSettings';
import { FormValidation } from '../services/FormValidation';
@Component({
  selector: 'app-timezonepopup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './timezonepopup.component.html',
  styleUrls: ['./timezonepopup.component.scss']
})
export class TimezonepopupComponent  extends FormValidation{
  freeLauchtimezoneFrom: UntypedFormGroup;
  modalRef: BsModalRef;
  timezoneslist: Array<string> = [];
  countryList: Array<Country> = [];
  @Output() response = new EventEmitter();
  @Output() modalopen = new EventEmitter();
  public FORMERROR = super.Form;
  stateList: Array<State> = [];

  userId: string = localStorage.getItem('userId');
  citiesSubject = new Subject<string>();
  @ViewChild('timezoneforFreelauncher', { static: true }) timezoneforFreelauncher: TemplateRef<any>;

  constructor(
    private API: ApiService,
    private modalService: BsModalService,
    private fb: UntypedFormBuilder,
    private util: UtilService,
    public gigsumoService: GigsumoService
  ) {
    super();
  }



  ngOnInit(){
   this.modelshowforTimeZone();
    this.searchUsZipCodes();
    this.getCountries();
  }
  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.API.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }

    }, err => {
      this.util.stopLoader();
    });
  }
  searchUsZipCodes() {
    this.citiesSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(res => {
      this.util.startLoader();
      this.gigsumoService.getUsaCities(res).subscribe(cities => {
        if (cities != null) {
          this.util.stopLoader();
          if (Array.isArray(cities)) {
            cities.forEach(element => {
              this.freeLauchtimezoneFrom.patchValue({ city: element.cityName, state: element.stateName })
            })
          }
        }
      }, error => {
        this.util.stopLoader();
      });
    });
  }
  modelshowforTimeZone() {
    this.freeLauchtimezoneFrom = new AppSettings().freelancerTimezone();
    this.modalService.show(this.timezoneforFreelauncher, { backdrop: 'static', keyboard: false, class: 'modal-md', ignoreBackdropClick: true });
  }
  disableFields(value: Array<string>) {
    for (let key of value) {
      this.freeLauchtimezoneFrom.get(key).disable();
      this.freeLauchtimezoneFrom.get(key).updateValueAndValidity();
    }
  }

  enableFields(value: Array<string>) {
    for (let key of value) {
      this.freeLauchtimezoneFrom.get(key).enable();
      this.freeLauchtimezoneFrom.get(key).updateValueAndValidity();
    }
  }


  getCities(value: string) {
    if (value && value.length >= 4) {
      this.disableFields(['state', 'city']);
      this.citiesSubject.next(value);
    }
  }
  onChangeCountrypatchvalue(countryCode: string) {

    if (countryCode === "US") {
      this.disableFields(['state', 'city']);
    }
    else {
      this.enableFields(['state', 'city']);
    }
    this.freeLauchtimezoneFrom.patchValue({
      state: null,
      zipcode: null,
      city: null,
      country: countryCode,
      timeZone: null
    });

    if (countryCode.trim().length > 0) {
      this.util.startLoader()
      this.API.query("country/getAllStates?countryCode=" + countryCode).subscribe((res) => {
        if (res) {
          this.util.stopLoader();
          this.stateList = res;
        }
      });
      this.timeZonecountryvalues(countryCode);
    }
  }

  get getcontrolforFreelaucher() {
    return this.freeLauchtimezoneFrom.controls
  }
  timeZonecountryvalues(countryCode: string) {
    if (countryCode != undefined && countryCode != "") {
      this.API.query("user/timeZoneByCountryCode/" + countryCode).subscribe((res) => {
        if (res) {
          this.util.stopLoader();
          this.timezoneslist = res.data.zones;
        }
      }, err => {
        this.util.stopLoader();
      });
    }

  }
  modelclose() {
    this.modalService.hide(1);
    this.response.emit({ content: 'SUCESS' });
  }

  saveusertimezone(): void {
    this.freeLauchtimezoneFrom.markAllAsTouched();
    if (this.freeLauchtimezoneFrom.valid) {
      this.util.startLoader();
      const formValues = this.freeLauchtimezoneFrom.getRawValue();
      const userData = {
        timeZoneCountry: formValues.country,
        state: formValues.state,
        timeZone: formValues.timeZone,
        city: formValues.city,
        country: formValues.country,
        zipcode: formValues.zipcode,
      };
      this.API.query(`user/${this.userId}`).subscribe(
        (res) => {
          Object.assign(res, userData);
          this.API.create("user/updateUser", res).subscribe(
            (updateResponse) => {
              this.util.stopLoader();
              if (updateResponse.code === "00000") {
                this.modalService.hide(1);
                Swal.fire({
                  icon: "success",
                  title: "Updated successfully.",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.modalopen.emit({ content: 'SUCESS' });
              }
            },
            (error) => {
              this.util.stopLoader();
            }
          );
        },
        (error) => {
          this.util.stopLoader();
        }
      );
    }
  }

}
